export function addEvent(object, type, callback, propagation) {
  if (object === null || typeof object === "undefined") return;
  if (object.addEventListener) {
    object.addEventListener(
      type,
      callback,
      propagation === undefined ? false : propagation
    );
  } else if (object.attachEvent) {
    object.attachEvent(`on${type}`, callback);
  } else {
    object[`on${type}`] = callback;
  }
}

export function removeEvent(object, type, callback, propagation) {
  if (object === null || typeof object === "undefined") return;
  if (object.removeEventListener) {
    object.removeEventListener(
      type,
      callback,
      propagation === undefined ? false : propagation
    );
  } else if (object.attachEvent) {
    object.dettachEvent(`on${type}`, callback);
  } else {
    object[`on${type}`] = callback;
  }
}

export function hasParentNode(currentNode, node) {
  if (currentNode === node) return true;
  if (currentNode.parentNode) {
    if (currentNode.parentNode === node) {
      return true;
    }
    return hasParentNode(currentNode.parentNode, node);
  }
}

export function removeChildNodes(node) {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }
}

export function replaceNodeChildrenWithNode(targetNode, newChildNode) {
  removeChildNodes(targetNode);
  targetNode.append(newChildNode);
}

export function replaceContentInNode(node, content) {
  const tpl = document.createElement("template");
  tpl.innerHTML = content;
  removeChildNodes(node);
  try {
    node.appendChild(tpl.content);
  } catch (e) {
    node.innerHTML = content;
  }
}

export function appendContentToNode(node, content) {
  const tpl = document.createElement("template");
  tpl.innerHTML = content;
  try {
    node.appendChild(tpl.content);
  } catch (e) {
    node.innerHTML = content;
  }
}

export function toggleAttribute(element, attribute) {
  if (!element) {
    return;
  }

  if (element.getAttribute(attribute) === "true") {
    element.setAttribute(attribute, "false");
  } else {
    element.setAttribute(attribute, "true");
  }
}

export function getFirstFocusableChild(element) {
  if (!element) {
    return;
  }

  return element.querySelector("button, a, input");
}

export function isValidEmail(email) {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}
